module.exports = ":host {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/petal-logo/petal-logo.component.scss
// module id = 147
// module chunks = 0